module.exports = __webpack_public_path__ + "789f781a26a49feca79e4e17dfe12f8b.svg";